import { Text, VStack } from '@montel/montelpro-shared-components-v2';
import { StandardModal } from 'components/common/Modal/StandardModal';
import CreateCompanyForm from 'components/companies/CreateCompanyForm';
import { initialFormState } from 'components/companies/initialFormState';
import { FunctionComponent } from 'react';

interface CreateCompanyModalProps {
	showModal: boolean;
	setShowModal: (showModal: boolean) => void;
	onCompanyCreated?: () => void;
}

export const CreateCompanyModal: FunctionComponent<CreateCompanyModalProps> = ({
	showModal,
	setShowModal,
	onCompanyCreated,
}) => {
	const onCloseModal = () => {
		setShowModal(false);
	};

	const onSuccess = () => {
		onCloseModal();
		onCompanyCreated && onCompanyCreated();
	};

	return (
		<StandardModal
			isOpen={showModal}
			onClose={onCloseModal}
			header={'Create Company'}
		>
			<VStack gap="lg">
				<Text>Create an unlinked company</Text>
				<CreateCompanyForm
					initialFormState={initialFormState}
					onSuccess={onSuccess}
					onCancel={onCloseModal}
				/>
			</VStack>
		</StandardModal>
	);
};
